import { Check } from "lucide-react";
import { PARTS } from "@/lib/store";

const STATUS = [
  { id: "", label: "Não informar" },
  { id: "original", label: "Nenhuma trocada" },
  { id: "trocadas", label: "Teve troca" },
];

const KINDS = [["original", "Original Apple"], ["genuina", "Genuína Apple"], ["nao", "Não original"]];

const pill = (on) => `rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${on ? "border-white bg-white text-black" : "border-white/15 text-zinc-300 hover:border-white/40"}`;

export const PartsFields = ({ form, setForm }) => {
  const parts = Array.isArray(form.parts) ? form.parts : [];
  const has = (id) => parts.find((x) => x.part === id);
  const setStatus = (parts_status) => setForm((f) => ({ ...f, parts_status, parts: parts_status === "trocadas" ? f.parts || [] : [] }));
  const toggle = (id) => setForm((f) => ({ ...f, parts: has(id) ? parts.filter((x) => x.part !== id) : [...parts, { part: id, original: false }] }));
  // Origem da peça trocada: Original Apple, Genuína Apple (peça Apple na troca) ou não original.
  const setKind = (id, kind) => setForm((f) => ({ ...f, parts: parts.map((x) => (x.part === id ? { ...x, original: kind === "original", genuine: kind === "genuina" } : x)) }));

  return (
    <details data-testid="product-parts-section" open={!!form.parts_status} className="group rounded-xl border border-white/10 bg-white/[0.03] px-3.5 py-3">
      <summary className="cursor-pointer list-none text-xs text-zinc-400 marker:hidden">
        <span className="text-zinc-200">Peças trocadas</span> · opcional
      </summary>
      <div className="mt-3 space-y-3">
        <div className="flex flex-wrap gap-2">
          {STATUS.map((s) => (
            <button key={s.id || "none"} type="button" data-testid={`parts-status-${s.id || "none"}`} onClick={() => setStatus(s.id)} className={pill(form.parts_status === s.id)}>{s.label}</button>
          ))}
        </div>
        {form.parts_status === "original" && <p className="text-xs text-zinc-400">Mostra o selo "Original Apple" na página do aparelho.</p>}
        {form.parts_status === "trocadas" && (
          <ul className="space-y-2">
            {PARTS.map((p) => {
              const item = has(p.id);
              return (
                <li key={p.id} className="flex flex-wrap items-center justify-between gap-2">
                  <button type="button" data-testid={`parts-toggle-${p.id}`} onClick={() => toggle(p.id)} className={`flex items-center gap-2 ${pill(!!item)}`}>
                    {item && <Check className="h-3 w-3" />} {p.label}
                  </button>
                  {item && (
                    <div className="flex flex-wrap gap-1.5">
                      {KINDS.map(([kind, label]) => {
                        const on = (item.original ? "original" : item.genuine ? "genuina" : "nao") === kind;
                        return <button key={kind} type="button" data-testid={`parts-kind-${p.id}-${kind}`} aria-pressed={on} onClick={() => setKind(p.id, kind)} className={pill(on)}>{label}</button>;
                      })}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </details>
  );
};
